// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select {
  font-size: 14px;
}
select option {
  font-size: 13px;
}

tr.highlighted_row {
  background-color: #e3b5bb;
  color: #fff;
}
tr.highlighted_row:hover > * {
  color: #fff !important;
}
tr.highlighted_row:nth-of-type(2n+1) > * {
  color: #fff !important;
}
tr.highlighted_row td {
  color: #fff;
  justify-content: center;
  align-items: center;
}

.top-heading {
  position: relative;
  justify-content: center;
  background: #000000;
  color: white;
  padding: 7px 10px 7px 0px;
  display: flex;
  margin-bottom: 0px;
  width: calc(100% - 60px);
  margin-top: 0px;
  border-radius: 0px;
  height: 50px;
}

.category-tree {
  font-size: 13px;
}

#SaleInformation_component {
  background-color: #F4F4F4;
  width: 30%;
  padding: 0 20px;
  padding-top: 15px;
  position: fixed;
  right: 0;
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
#SaleInformation_component .workflow-activities {
  padding-bottom: 50px !important;
}
#SaleInformation_component .quality-check-box {
  margin: 20px 0;
}
#SaleInformation_component .modifiedDesign {
  color: red;
}
#SaleInformation_component img {
  width: 100px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SaleInformation_component {
    display: none;
    height: 30%;
    top: 70%;
    width: 100%;
  }
}
#SaleInformation_component h2 {
  text-align: center;
  padding: 6px 2px;
}
#SaleInformation_component .accordion-item .accordion-header {
  text-align: center;
  padding: 0px 0px;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button {
  background-color: white;
  color: black;
  text-align: left;
  width: 100%;
  padding: 5px 15px;
  display: block;
  border-bottom: 1px solid #dbb7bb;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button:focus {
  outline: none;
  box-shadow: none;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button.collapsed {
  border-bottom: 1px solid transparent;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button::after {
  display: inline-block;
  float: right;
}
#SaleInformation_component .choose_message {
  margin-top: 50px;
  text-align: center;
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#SaleInformation_component .choose_message span {
  font-size: 40px;
}

.documents-list table {
  font-size: 13px;
}
.documents-list table thead {
  background-color: white;
  position: sticky;
  top: 0;
}
.documents-list table thead tr.titles {
  border-style: hidden;
  background: #000000;
  color: white;
}
.documents-list table thead tr.titles th {
  position: sticky;
  top: 0;
  vertical-align: baseline;
}
@media only screen and (max-width: 1760px) {
  .documents-list table thead tr.titles th {
    font-size: 10px;
  }
}
@media only screen and (max-width: 1280px) {
  .documents-list table thead tr.titles th {
    font-size: 9px;
  }
}
.documents-list table thead tr.filters th {
  gap: 10px;
}
.documents-list table thead tr.filters th input {
  width: 100%;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
}
.documents-list table tbody tr {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/css/documentation/main.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;AAGI;EACI,eANY;AAKpB;;AAKA;EACI,yBAAA;EACA,WAAA;AAFJ;AAII;EACI,sBAAA;AAFR;AAKI;EACI,sBAAA;AAHR;AAMI;EACI,WAAA;EACA,uBAAA;EACA,mBAAA;AAJR;;AAQA;EACI,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AALJ;;AAQA;EACI,eA5CgB;AAuCpB;;AAQA;EAaI,yBAAA;EAMA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;AAtBJ;AALI;EACI,+BAAA;AAOR;AAJI;EACI,cAAA;AAMR;AAHI;EACI,UAAA;AAKR;AAAI;EACI,YAAA;AAER;AAYI;EA9BJ;IA+BQ,aAAA;IACA,WAAA;IACA,QAAA;IACA,WAAA;EATN;AACF;AAWI;EACI,kBAAA;EACA,gBAAA;AATR;AAaQ;EACI,kBAAA;EACA,gBAAA;AAXZ;AAaY;EACI,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AAXhB;AAagB;EACI,aAAA;EACA,gBAAA;AAXpB;AAcgB;EACI,oCAAA;AAZpB;AAegB;EACI,qBAAA;EACA,YAAA;AAbpB;AAqBI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAnBR;AAqBQ;EACI,eAAA;AAnBZ;;AAyBI;EACI,eA3IY;AAqHpB;AAwBQ;EACI,uBAAA;EACA,gBAAA;EACA,MAAA;AAtBZ;AAwBY;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;AAtBhB;AAwBgB;EACI,gBAAA;EACA,MAAA;EACA,wBAAA;AAtBpB;AAwBoB;EALJ;IAMQ,eAAA;EArBtB;AACF;AAuBoB;EATJ;IAUQ,cAAA;EApBtB;AACF;AAyBgB;EACI,SAAA;AAvBpB;AAyBoB;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;AAvBxB;AA8BY;EACI,eAAA;AA5BhB","sourcesContent":["$font_size_content: 13px;\n\nselect {\n    font-size: 14px; // set the font size for the select element\n\n    option {\n        font-size: $font_size_content; // set the font size for all options within the select element\n    }\n}\n\ntr.highlighted_row {\n    background-color: #e3b5bb;\n    color: #fff;\n\n    &:hover>* {\n        color: #fff !important;\n    }\n\n    &:nth-of-type(2n+1)>* {\n        color: #fff !important;\n    }\n\n    td {\n        color: #fff;\n        justify-content: center;\n        align-items: center;\n    }\n}\n\n.top-heading {\n    position: relative;\n    justify-content: center;\n    background: #000000;\n    color: white;\n    padding: 7px 10px 7px 0px;\n    display: flex;\n    margin-bottom: 0px;\n    width: calc(100% - 60px);\n    margin-top: 0px;\n    border-radius: 0px;\n    height: 50px;\n}\n\n.category-tree {\n    font-size: $font_size_content;\n}\n\n#SaleInformation_component {\n    .workflow-activities {\n        padding-bottom: 50px !important;\n    }\n\n    .quality-check-box {\n        margin: 20px 0;\n    }\n\n    .modifiedDesign {\n        color: red;\n    }\n\n    background-color: #F4F4F4;\n\n    img {\n        width: 100px;\n    }\n\n    width: 30%;\n    padding: 0 20px;\n    padding-top: 15px;\n    position: fixed;\n    right: 0;\n    height: 100%;\n    overflow: auto;\n    padding-bottom: 100px;\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n\n    @media all and (min-width:0px) and (max-width: 600px) {\n        display: none;\n        height: 30%;\n        top: 70%;\n        width: 100%;\n    }\n\n    h2 {\n        text-align: center;\n        padding: 6px 2px;\n    }\n\n    .accordion-item {\n        .accordion-header {\n            text-align: center;\n            padding: 0px 0px;\n\n            .accordion-button {\n                background-color: white;\n                color: black;\n                text-align: left;\n                width: 100%;\n                padding: 5px 15px;\n                display: block;\n                border-bottom: 1px solid #dbb7bb;\n\n                &:focus {\n                    outline: none;\n                    box-shadow: none;\n                }\n\n                &.collapsed {\n                    border-bottom: 1px solid transparent;\n                }\n\n                &::after {\n                    display: inline-block;\n                    float: right;\n                }\n            }\n        }\n\n        .accordion-collapse {}\n    }\n\n    .choose_message {\n        margin-top: 50px;\n        text-align: center;\n        font-size: 30px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n\n        span {\n            font-size: 40px;\n        }\n    }\n}\n\n.documents-list {\n    table {\n        font-size: $font_size_content;\n\n        thead {\n            background-color: white;\n            position: sticky;\n            top: 0;\n\n            tr.titles {\n                border-style: hidden;\n                background: #000000;\n                color: white;\n\n                th {\n                    position: sticky;\n                    top: 0;\n                    vertical-align: baseline;\n\n                    @media only screen and (max-width: 1760px) {\n                        font-size: 10px;\n                    }\n\n                    @media only screen and (max-width: 1280px) {\n                        font-size: 9px;\n                    }\n                }\n            }\n\n            tr.filters {\n                th {\n                    gap: 10px;\n\n                    input {\n                        width: 100%;\n                        border: 1px solid #d2d2d2;\n                        border-radius: 3px;\n                    }\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                cursor: pointer;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
